import { computed, toValue, type ComputedRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

import type { BreadcrumbItem } from '@/models/breadcrumb-item';

interface UseBreadcrumbMenuOptions<T> {
  steps: T[];
  translationNamespace: string;
  routePrefix?: string;
  extraPath?: string;
}

export function useBreadcrumbMenu<T>(options: ComputedRef<UseBreadcrumbMenuOptions<T>>) {
  const { t } = useI18n();
  const route = useRoute();

  const breadcrumbItems = computed((): BreadcrumbItem<T>[] => {
    const { steps, translationNamespace, routePrefix, extraPath } = toValue(options);

    return steps.map((step) => ({
      id: step,
      name: t(`${translationNamespace}.breadcrumb_menu.${step}`),
      routerPath: `/${routePrefix}/${extraPath ?? ''}/${step}`.replace(/\/{2,}/g, '/'),
    }));
  });

  const currentStep = computed(() => route.params['step'] as T);

  return {
    currentStep,
    breadcrumbItems,
  };
}
